import React, { useState } from 'react'
import LoadingIndicator from 'src/common/components/LoadingIndicator'
import { CloseDrawer } from 'src/common/icons/closeDrawer'
import EmptyTrainingModulePage from './EmptyTrainingModulePage'
import ModuleItem from './ModuleItem'
import './styles.css'
import { useNavigate } from 'react-router-dom'
import { Box, Button } from '@mui/material'
import GenerateModuleButton from './GenerateModuleButton'

export default function MicroTrainingPreview({
  item,
  modules,
  modulesLoading,
  language,
  onClose,
  onModulePreview,
  onGenerateClick
}) {
  if (!item) return null

  const filledModules = modules?.filter(module => module.type !== null) || []
  const navigate = useNavigate()

  const handleEditModule = moduleId => {
    navigate(`/topics/${item.trainingId}/modules/${moduleId}/edit`, {
      state: {
        type: item.type,
        language
      }
    })
  }

  return (
    <div className='micro-preview-container column'>
      <PreviewHeader title={item.topic} onClose={onClose} />
      <ModulesCounter modules={filledModules} />

      {modulesLoading ? (
        <LoadingIndicator />
      ) : (
        <ModulesList
          modules={filledModules}
          onModulePreview={onModulePreview}
          onEditModule={handleEditModule}
          topicId={item.trainingId}
          topicType={item.type}
          onGenerateClick={onGenerateClick}
        />
      )}
    </div>
  )
}

function PreviewHeader({ title, onClose }) {
  return (
    <>
      <div className='micro-preview-close-button' onClick={onClose}>
        <CloseDrawer />
      </div>
      <div className='row row-center'>
        <p className='micro-drawer-title'>{title}</p>
      </div>
    </>
  )
}

function ModulesCounter({ modules }) {
  const activeCount = modules?.filter(el => el.active)?.length
  const totalCount = modules?.length

  return (
    <p className='micro-preview-modules-count'>
      {activeCount}/{totalCount}
      <span className='micro-preview-modules-label'>active modules</span>
    </p>
  )
}

function ModulesList({ modules, onModulePreview, onEditModule, topicId, topicType, onGenerateClick }) {
  const navigate = useNavigate()

  function handleCreateModule() {
    if (topicId) {
      navigate(`/topics/${topicId}/modules/create`)
    } else {
      console.error('TopicId is undefined')
    }
  }

  return (
    <Box display={'flex'} flexDirection={'column'} gap={2} width={'100%'}>
      {!modules?.length ? (
        <EmptyTrainingModulePage>
          {topicType === 'CUSTOM' && (
            <div className='row' style={{ justifyContent: 'center', gap: 10 }}>
              <Box display={'flex'} justifyContent={'center'}>
                <Button onClick={handleCreateModule} sx={styles.button}>
                  Add Module
                </Button>
              </Box>
              <Box display={'flex'} justifyContent={'center'}>
                <GenerateModuleButton onClick={onGenerateClick} />
              </Box>
            </div>
          )}
        </EmptyTrainingModulePage>
      ) : (
        <>
          {modules.map((el, index) => (
            <ModuleItem
              item={el}
              index={index}
              key={el.trainingModuleId}
              onPreview={onModulePreview}
              onEdit={() => onEditModule(el.trainingModuleId)}
            />
          ))}
          {topicType === 'CUSTOM' && (
            <div className='row' style={{ justifyContent: 'center', gap: 10 }}>
              <Box display={'flex'} justifyContent={'center'}>
                <Button onClick={handleCreateModule} sx={styles.button}>
                  Add Module
                </Button>
              </Box>
              <Box display={'flex'} justifyContent={'center'}>
                <GenerateModuleButton onClick={onGenerateClick} />
              </Box>
            </div>
          )}
        </>
      )}
    </Box>
  )
}

const styles = {
  button: {
    padding: '0px 30px',
    background: '#6123FF',
    borderRadius: '14px',
    fontFamily: 'Plus Jakarta Sans',
    fontSize: '16px',
    height: '40px',
    color: '#fff',
    textTransform: 'none',
    border: 'none',
    '&:hover': { background: '#1565c0' }
  }
}
